export const headerPlatformContent = {
    en:{
        myExe: "Exercises",
        notif: "Notifications",
        signout: "Sign Out",
    },
    sl:{
        myExe: "Vaje",
        notif: "Obvestila",
        signout: "Odjava",
    },
} as const;